import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const AdminPrivateRoute: React.FC = () => {
  const isAdminLoggedIn = useSelector(
    (state: RootState) => state.auth.admin.isLoggedIn,
  );

  if (!isAdminLoggedIn) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminPrivateRoute;
